import axios from 'axios';

/**
 * @typedef {object} Assignment
 * @property {number} id
 * @property {string} name
 * @property {string} courseId
 * @property {number} instanceId
 * @property {string} availableDate
 * @property {string} dueDate
 * @property {number} difficulty
 * @property {number} points
 * @property {string} image
 * @property {object} video
 * @property {number} videoId
 * @property {number} week
 * Potentially more...
 */

export default {
    create(context, data) {
        var options = {
            method: 'POST',
            url: window.apiUrl + '/assignment',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    update(context, data) {
        var options = {
            method: 'PATCH',
            url: window.apiUrl + '/assignment',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    delete(context, id) {
        var options = {
            method: 'DELETE',
            url: window.apiUrl + '/assignment/' + id,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    get(context, courseId, instanceId, week) {
        var url = window.apiUrl + '/assignments';

        if (courseId) {
            url += '/' + courseId
        }
        if (instanceId) {
            url += '/' + instanceId
        }
        if (week) {
            url += '?week=' + week
        }
        var options = {
            method: 'GET',
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getAll(context, limit, myCourses, includeFuture) {

        var url = window.apiUrl + '/assignments';

        if (limit) {
            url += '?limit=' + limit
        }

        if (includeFuture) {
            url += '?includeFuture=true';
        }
        var options = {
            method: 'GET',
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    submit(context, data) {
        var options = {
            method: 'POST',
            url: window.apiUrl + '/assignment-submission',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getSubmissions(context, assignmentId, studentId) {
        var url = window.apiUrl + '/submissions';
        if (assignmentId) {
            url += '?assignment_id=' + assignmentId
        }
        else if (studentId) {
            url += '?student_id=' + studentId
        }
        var self = this;
        var options = {
            method: 'GET',
            url: url,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    getFeedback(params) {
        const options = {
            method: 'GET',
            url: window.apiUrl + '/assignment-feedback?supervisorId=' + params.supervisorId + '&termId=' + params.termId + '&groups=' + params.groups,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    addFeedback(context, feedback) {
        var options = {
            method: 'POST',
            url: window.apiUrl + '/feedback',
            data: feedback,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },
    grade(context, id, data) {
        var options = {
            method: 'PATCH',
            url: window.apiUrl + '/assignment/' + id,
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    },

    watermark(type, record, file) {
        const data = {
            type: type,
            record: record,
            file: file
        }

        const options = {
            method: 'POST',
            url: window.apiUrl + '/watermark',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });

    },

    /**
     * @param {object} [query]
     * @param {string} [query.termId]
     * @param {number} [query.pathId]
     * @returns {Assignment[]}
     */
    async search(query = {}) {
        // Get all assignments
        let options = {
            method: 'GET',
            baseURL: window.apiUrl,
            url: '/assignments',
            headers: {
              'Authorization': 'Bearer ' + localStorage.token
            }
        };
        const assignmentsRes = await axios.request(options);
        if (!assignmentsRes.data.success) {
            throw new Error(assignmentsRes.data.error);
        }
        const assignments = assignmentsRes.data.assignments;

        // Get instances in term
        options = {
            method: 'GET',
            baseURL: window.apiUrl,
            url: '/instances',
            params: {
              termId: query.termId,
              pathId: query.pathId
            },
            headers: {
              'Authorization': 'Bearer ' + localStorage.token
            }
        };
        const instancesRes = await axios.request(options);
        if (!instancesRes.data.success) {
            throw new Error(instancesRes.data.error);
        }
        const instances = instancesRes.data.instances;

        // Filter assignments by term instances
        return assignments.filter(a => {
            return !!instances.find(i => i.id == a.instanceId);
        });
    },

    /**
     * @async
     * @param {number} id
     * @returns {Assignment}
     */
    getAssignment(id) {
      // TODO: use server-side route like /assignments/:id instead of just filtering
      // through all assignments
      return module.exports.default.search().then(assignments => {
        const assignment = assignments.find(a => a.id == id);
        if (!assignment) {
          throw new Error('assignment not found');
        }
        return assignment;
      });
    },

    convertToGallery(submission) {
        const data = {
            submission: submission,
        }

        const options = {
            method: 'POST',
            url: window.apiUrl + '/submission-to-gallery',
            data: data,
            headers: {'Authorization': 'Bearer ' + localStorage.token}
        };
        return axios.request(options).then(function(response) {
            return response;
        });
    }

};



// WEBPACK FOOTER //
// ./src/services/assignments/index.js